<script setup>
import { computed } from "vue";
import AnimatedArrow from "@components/AnimatedArrow.vue";
import { useSmoothScroll } from "@composables/useSmoothScroll";

const props = defineProps({
  href: { type: String, default: undefined },
  label: { type: String, default: undefined },
  sublabel: { type: String, default: undefined },
  variant: { type: String, default: "primary" },
});

const tag = computed(() => (props.href ? "a" : "button"));

const { handleAnchorClick } = useSmoothScroll();
</script>

<template>
  <component
    :is="tag"
    :href="href"
    class="group relative flex h-[123px] items-end justify-between overflow-clip rounded-[8px] p-[16px] flex-1"
    @click="handleAnchorClick($event, href)"
    :class="[
      variant === 'primary'
        ? 'bg-black text-primary'
        : 'bg-primary text-black outline-[#0000001A] outline hover:outline-2 transition-all duration-300',
    ]"
  >
    <div class="flex flex-col items-start justify-center gap-[8px]">
      <span
        v-if="label"
        class="font-obviously font-bold text-[14px] leading-none tracking-[-0.14px]"
      >
        {{ label }}
      </span>
      <span
        v-if="sublabel"
        class="font-obviously text-[10px] leading-none tracking-[-0.1px] text-white/60"
      >
        {{ sublabel }}
      </span>
    </div>

    <AnimatedArrow v-if="variant === 'primary'" :size="28" class="shrink-0" />
  </component>
</template>
